import PaymentService from '../../../services/PaymentService'
import { SET_LOADING, SET_PAYMENT_STATE_VALUE, SET_PRICE_RESPONSE } from './variables'
import Camelize from '../../../services/Camelize'

const state = {
  loading: false,
  paymentSecret: localStorage.getItem('paymentSecret') || '',
  stripeApiKey: localStorage.getItem('stripeApiKey') || '',
  paymentIntent: localStorage.getItem('paymentIntent') || '',
  price: localStorage.getItem('price') || '',
  currency: localStorage.getItem('currency') || '',
  coupon: localStorage.getItem('coupon') || '',
  discountAmount: 0
}

const mutations = {
  [SET_LOADING]: (state, value) => {
    state.loading = value
  },
  [SET_PAYMENT_STATE_VALUE]: (state, value) => {
    state[value[0]] = value[1]
  },
  [SET_PRICE_RESPONSE]: (state, payload) => {
    const price = (payload.amount / 100).toFixed(2)
    localStorage.setItem('price', price)
    localStorage.setItem('currency', payload.currency)
    payload.discountAmount && localStorage.setItem('discountAmount', payload.discountAmount)
    payload.discountCoupon && localStorage.setItem('coupon', payload.discountCoupon)
    state.price = price
    state.currency = payload.currency
    state.discountAmount = payload.discountAmount
    state.coupon = payload.discountCoupon
  }
}

const getters = {
  paymentSecret: state => state.paymentSecret,
  stripeApiKey: state => state.stripeApiKey,
  paymentIntent: state => state.paymentIntent,
  price: state => state.price,
  currency: state => state.currency,
  coupon: state => state.coupon,
  loading: state => state.loading
}

const actions = {
  async startPaymentRequest({ commit, dispatch }) {
    commit(SET_LOADING, true)
    try {
      const response = await PaymentService.startPayment()

      if (response && response.data.response) {
        const paymentSecret = response.data.response.payment_secret
        const stripeApiKey = response.data.response.stripe_api_key

        localStorage.setItem('paymentSecret', paymentSecret)
        localStorage.setItem('stripeApiKey', stripeApiKey)
        commit(SET_PAYMENT_STATE_VALUE, ['paymentSecret', paymentSecret])
        commit(SET_PAYMENT_STATE_VALUE, ['stripeApiKey', stripeApiKey])

        return stripeApiKey
      }
    } catch (error) {
      const errorMessage = (error.response && error.response.data.message) || error
      dispatch('base/pushAlertMessage', { message: errorMessage }, { root: true })
      return false
    } finally {
      commit(SET_LOADING, false)
    }
  },
  async confirmPaymentRequest({ dispatch, getters, commit }, payload) {
    commit(SET_LOADING, true)
    try {
      const response = await payload.stripeInstance.confirmCardPayment(getters.paymentSecret, {
        payment_method: {
          card: payload.card
        }
      })
      if (response && response.paymentIntent && response.paymentIntent.id) {
        localStorage.setItem('paymentIntent', response.paymentIntent.id)

        return true
      } else {
        throw response.error.message
      }
    } catch (error) {
      dispatch('base/pushAlertMessage', { message: error }, { root: true })
      return false
    } finally {
      commit(SET_LOADING, false)
    }
  },
  async exportPriceRequest({ dispatch, commit }) {
    commit(SET_LOADING, true)
    try {
      const response = await PaymentService.getExportPrice()

      if (response && response.data.response) {
        commit(SET_PRICE_RESPONSE, Camelize.priceFromDto(response.data.response))

        return true
      }
    } catch (error) {
      const errorMessage = (error.response && error.response.data.message) || error
      dispatch('base/pushAlertMessage', { message: errorMessage }, { root: true })
      return false
    } finally {
      commit(SET_LOADING, false)
    }
  },
  async applyCoupon({ dispatch, commit }, value) {
    commit(SET_LOADING, true)
    try {
      const response = await PaymentService.applyCoupon(value)

      if (response && response.data.response) {
        commit(SET_PRICE_RESPONSE, Camelize.priceFromDto(response.data.response))

        return true
      }
    } catch (error) {
      const errorMessage = (error.response && error.response.data.detail.message) || error
      dispatch('base/pushAlertMessage', { message: errorMessage }, { root: true })
      return false
    } finally {
      commit(SET_LOADING, false)
    }
  }
}

export default {
  namespaced: true,

  state,
  getters,
  actions,
  mutations
}
